import { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { failureToast } from '../../../../support/utils';
import { DetailRow, yesNo } from '../../components/DetailRow';
import { defaultCancellation, ICancellation } from '../../models/Cancellation';
import { viewCancellation } from '../../redux/CancellationsCRUD';

export const ViewCancellation = () => {
  const { id } = useParams<{ id: string }>();

  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<ICancellation>(defaultCancellation);

  const handleFetch = async (id: string) => {
    setLoading(true);
    try {
      const result = await viewCancellation(id);
      setData(result);
      setLoading(false);
    } catch (error) {
      failureToast(error);
      setLoading(false);
    }
  };

  useEffect(() => {
    if (id) {
      handleFetch(id);
    }
  }, [id]);

  return (
    <div className={`card ${loading ? 'overlay overlay-block' : ''}`}>
      <div className="card-header">
        <h3 className="card-title">Cancellation</h3>
      </div>

      <div className={`card-body py-10 ${loading ? 'overlay-wrapper' : ''}`}>
        <div className="mw-800px mx-auto">
          <DetailRow label="Name" value={data.name} />
          <DetailRow label="Email" value={data.email} />
          <DetailRow label="Company" value={data.company_name} />
          <DetailRow label="Customer number" value={data.customer_number} />
          <DetailRow label="Desired end date" value={data.desired_end_date} />
          <DetailRow label="Reason category" value={data.reason_category} />
          <DetailRow label="Reason for cancellation" value={data.reason} />
          <DetailRow
            label="Improvement suggestion"
            value={data.improvement_suggestion}
          />
          <DetailRow label="Agreed" value={yesNo(data.terms_accepted)} />
          <DetailRow label="Submitted at" value={data.created_at} />

          <div className="row pt-5">
            <div className="col-lg-12">
              <Link
                className="btn btn-color-gray-600 btn-active-light-primary fw-bolder px-6 py-3"
                to="/form-management/cancellations"
              >
                Back
              </Link>
            </div>
          </div>
        </div>

        {loading && (
          <div className="overlay-layer rounded bg-dark bg-opacity-5">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
